<app-date-picker-control
	[label]="label()"
	[controlName]="controlName()"
	[placeholder]="placeholder()"
	[required]="required()"
	[formGroup]="formGroup()"
/>
